import { type AxiosResponse } from 'axios'
import { chunk } from 'lodash'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import { type IResponseContacts } from 'entities/Contacts/api/types'
import {
  type IParamsContactsTagsById,
  type IParamsTagsPerPage,
  type IParamsUpdateTagById,
  type IResponseDeleteTagById,
  type IResponseTag,
  type IResponseTagsPerPage,
} from './types'

class Api {
  getAllTags(): Promise<AxiosResponse<IResponseTagsPerPage>> {
    const params = {
      page: 1,
      sortBy: 'created_at',
      sortOrder: 'desc',
      length: 1000,
    }

    return baseApi.get('tags', { params })
  }

  getTagById(id: number): Promise<AxiosResponse<IResponseTag>> {
    return baseApi.get(`tags/${id}`)
  }

  getContactsTagsById(
    id: number,
    params?: IParamsContactsTagsById,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseContacts>> {
    return baseApi.get(`contacts/tags/${id}`, { ...options, params })
  }

  getTagsPerPage(
    params: IParamsTagsPerPage,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseTagsPerPage>> {
    return baseApi.get('tags/paginated', { ...options, params })
  }

  async getTagsById(ids: number[]): Promise<IResponseTag[]> {
    if (!ids.length) {
      return []
    }
    const res = await Promise.all(
      chunk(ids, 100).map((chunkIds) =>
        this.getTagsPerPage({
          ids: chunkIds,
          length: 100,
        })
      )
    )

    return res.map((item) => item.data.data).flat()
  }

  createTag({ label }: { label: string }): Promise<AxiosResponse<IResponseTag>> {
    return baseApi.post('tags', { label })
  }

  updateTagById(id: number, params: IParamsUpdateTagById): Promise<AxiosResponse<IResponseTag>> {
    return baseApi.put(`tags/${id}`, params)
  }

  deleteTagById(id: number): Promise<AxiosResponse<IResponseDeleteTagById>> {
    return baseApi.delete(`tags/${id}`)
  }

  deleteBulkTags(ids: number[], bulkAll: 0 | 1 = 0): Promise<AxiosResponse> {
    return baseApi.delete('tags', { params: { ids, delete_all: bulkAll } })
  }
}

export const TagsApi = new Api()
